



























































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
@Component
export default class AuthView extends Vue {
  maintenance = false;
  mounted() {
    this.getGlobalParams();
  }
  showHelp(): void {
    window.open("https://nubii.us/bot/c", "_blank").focus();
  }
  async getGlobalParams(): Promise<void> {
    await this.$store.dispatch("SpaceStore/getGlobalParamsAction", {
      callback: async (response) => {
        if (response.data.MAINTENANCE_STATUS == "ON") {
          await this.$store.dispatch(
            "SystemStore/setMaintenanceStartAction",
            response.data.MAINTENANCE_START_AT
          );
          await this.$store.dispatch(
            "SystemStore/setMaintenaceFinishAction",
            response.data.MAINTENANCE_FINISH_AT
          );
          this.maintenance = true;
        }
      },
      callbackError: (error) => {
        this.maintenance = true;
      },
    });
  }
  get start(): string {
    const maintenanceStart =
      this.$store.getters["SystemStore/getMaintenanceStart"];
    return moment
      .utc(moment(parseInt(maintenanceStart) * 1000))
      .local()
      .format("h:mm a");
  }
  get finish(): string {
    const maintenanceFinish =
      this.$store.getters["SystemStore/getMaintenaceFinish"];
    return moment
      .utc(moment(parseInt(maintenanceFinish) * 1000))
      .local()
      .format("h:mm a");
  }
  get isMessageError(): boolean {
    const maintenanceMessageError =
      this.$store.getters["SystemStore/getMaintenanceMessageError"];
    return maintenanceMessageError;
  }
  retry() {
    window.location.reload();
  }
  isHawkings() {
    if (window.location.host.includes("hawkings.education")) {
      return true;
    }
    return false;
  }
}
